"use client";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body>
        <main className="flex min-h-screen items-center justify-center bg-black px-6 text-white">
          <section className="w-full max-w-xl rounded-2xl border border-white/10 bg-white/[0.03] p-6 text-center">
            <p className="text-xs font-bold uppercase tracking-[0.3em] text-red-300">
              Application error
            </p>

            <h1 className="mt-3 text-3xl font-black tracking-tight">
              Something went wrong.
            </h1>

            <p className="mt-3 text-sm text-white/60">
              The page crashed while loading. Try again, or go back to the
              homepage.
            </p>

            {error?.digest ? (
              <p className="mt-4 text-xs text-white/35">
                Error ID: {error.digest}
              </p>
            ) : null}

            <div className="mt-6 flex justify-center gap-3">
              <button
                type="button"
                onClick={() => reset()}
                className="rounded-xl bg-white px-4 py-2 text-sm font-bold text-black"
              >
                Try again
              </button>

              <a
                href="/"
                className="rounded-xl border border-white/10 px-4 py-2 text-sm font-bold text-white"
              >
                Go home
              </a>
            </div>
          </section>
        </main>
      </body>
    </html>
  );
}
